import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import DropdownButton from '../Dropdowns/DropdownButton';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  passActiveValueUp = () => {
    if (this.props.onClick) {
      this.props.onClick(this.state.active);
    }
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({ active: !this.state.active }, () => {
      this.passActiveValueUp();
    });
  }

  // Function from react-onClickOutside
  handleClickOutside = () => {
    this.setState({ active: false }, () => {
      this.passActiveValueUp();
    });
  }

  render() {
    const { children, label, size, position, dark, noArrow, buttonClasses, arrowFill } = this.props;

    const dropdownContainerClass = classNames('dropdown', {
      'dropdown--with-label': label,
      'dropdown--with-arrow': noArrow === undefined,
    });

    // The 'ignore-react-onclickoutside' class is needed to prevent clicks inside the dropdown menu from triggering the 'handleClickOutside' event
    // Which only appears to cause issues for dropdowns inside of horizontal scroll containers
    // https://github.com/Pomax/react-onclickoutside#marking-elements-as-skip-over-this-one-during-the-event-loop
    const dropdownClass = classNames('dropdown__menu', 'ignore-react-onclickoutside', `dropdown__menu--${size}`, `dropdown__menu--${position}`, {
      'dropdown__menu--active': this.state.active,
      'dropdown__menu--dark': dark,
    });

    return (
      <div className={dropdownContainerClass}>
        <DropdownButton onClick={e => this.handleClick(e)} label={label} noArrow={noArrow} iconFill={arrowFill} classes={buttonClasses} />
        <div className={dropdownClass}>
          {children}
        </div>
      </div>
    );
  }
}

Dropdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  size: PropTypes.string,
  position: PropTypes.string,
  dark: PropTypes.bool,
  noArrow: PropTypes.bool,
  onClick: PropTypes.func,
  buttonClasses: PropTypes.string,
  arrowFill: PropTypes.string,
};

export default onClickOutside(Dropdown);



// WEBPACK FOOTER //
// ./library/app/components/Global/Dropdowns/Dropdown.js